export interface Sizes {
	readonly top: number;
	readonly left: number;
	readonly width: number;
	readonly height: number;
}
export interface HighlightMaskProps {
	readonly sizes: Sizes;
	readonly id?: string;
	readonly onClick?: () => void;
	readonly isTransparent: boolean;
	readonly maskOnClickableArea?: boolean;
}

export interface HightlightSpotHookProps {
	readonly id?: string;
	readonly visible: boolean;
	readonly isTransparent: boolean;
	readonly query?: string;
	readonly maskOnClickableArea?: boolean;
}

export function getWindow(): { w: number; h: number } {
	const w = Math.max(
		document.documentElement.clientWidth,
		window.innerWidth || 0
	);
	const h = Math.max(
		document.documentElement.clientHeight,
		window.innerHeight || 0
	);
	return { w, h };
}

export const safe = (sum: number) => (sum < 0 ? 0 : sum);
